// src/api/index.js
import axios from 'axios';
import { createAppTransport } from '@1823-partners/core';

// Same-origin proxy: SWA Function in production, CRA proxy in local development.
const api = createAppTransport({ axios, appName: 'pricing' });

export const getPricingDates = async () => {
  return api.get('/pricing-dates');
};

export const getPricingEntries = async (asofdt) => {
  return api.get(`/pricing-entries?asofdt=${asofdt}`);
};

export const getBrokerHistory = async (broker, priceFile) => {
  return api.get(`/broker-entries?${new URLSearchParams({ broker, priceFile })}`);
};

export const getBrokerEntries = async () => {
  return api.get('/broker-entries');
};

export const getPricingEntryHistory = async (asofdt, id2) => {
  return api.get(`/pricing-history?${new URLSearchParams({ asofdt, id2 })}`);
};

export const getBrokerEntryHistory = async (priceFile, broker) => {
  return api.get(`/broker-history?${new URLSearchParams({ priceFile, broker })}`);
};

export const getMonthOverMonthPricingChecks = async (currentDate, previousDate) => {
  return api.get(`/mom-pricing-checks?currentDate=${currentDate}&previousDate=${previousDate}`);
};

export const getMonthOverMonthPricingNotes = async (asofdt) => {
  return api.get(`/mom-pricing-notes?asofdt=${asofdt}`);
};

export const savePricing = async (updatedRows) => {
  return api.post('/save-pricing', updatedRows);
};

export const saveBrokers = async (updatedRows) => {
  return api.post('/save-brokers', updatedRows);
};

export const saveMonthOverMonthPricingNotes = async (updatedRows) => {
  return api.post('/save-mom-pricing-notes', updatedRows);
};

export const deleteBrokerEntry = async (deleteEntry) => {
  return api.post('/delete-broker-entry', deleteEntry);
};

export const deletePricingEntry = async (deleteEntry) => {
  return api.post('/delete-pricing-entry', deleteEntry);
};

export const getUsePriceMap = async (asofdt) => {
  return api.get(`/use-price-map?asofdt=${asofdt}`);
};

export const getPricingFrequency = async () => {
  return api.get('/pricing-frequency');
};

export const getBrokerMap = async () => {
  return api.get('/broker-map');
};

export const savePricingFrequency = async (data) => {
  return api.post('/save-frequency', data);
};

export const deleteFrequencyEntry = async (data) => {
  return api.post('/delete-frequency-entry', data);
};

export const getFrequencyHistory = async (id2) => {
  return api.get(`/frequency-history?${new URLSearchParams({ id2 })}`);
};

// Export the api client for direct access if needed
export default api;
